import GoogleAnalyticsCompanion from "../../services/ga-companion";
import ParameterTracker from "../../services/parameter-tracker";

(() => {

  function handleFormSubmission(event) {

    if (event.target.tagName === 'FORM' && event.target.dataset.form_notes !== 'set') {
      // Make sure this form has the Note hidden field.
      const formElement = event.target;

      const noteHiddenElement = formElement.querySelector('input[type="hidden"][name="form_notes"]');

      // Only proceed if the form has the expected hidden field.
      if (noteHiddenElement) {
        event.preventDefault();

        const googleAnalyticsCompanion = new GoogleAnalyticsCompanion();

        // Build a list of key/value parameters of UTM parameters and the GCLID.
        const formParams = new URLSearchParams();

        // Define the parameters we're interested in.
        const parametersToTrack = [
          'utm_source',
          'utm_medium',
          'utm_campaign',
          'utm_term',
          'utm_content',
          'gclid',
          'trkid',
        ];

        // Loop through the list of parameters and get the value if present.
        for (const param of parametersToTrack) {
          const value = ParameterTracker.getParameterValue(param);

          if (value) {
            formParams.set(param, value);
          }
        }

        // Set the GA id.
        formParams.set('visitorid', googleAnalyticsCompanion.getID());

        // Find the Note hidden field in the form, and set the gathered values as a single query string.
        noteHiddenElement.value = formParams.toString();

        formElement.dataset.form_notes = 'set';

        formElement.submit();
      }

    }

  }

  document.addEventListener('DOMContentLoaded', () => {
    document.body.addEventListener('submit', handleFormSubmission);
  });

})();